document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".flex-layout.vacature_content-layout").forEach((layout) => {
        layout.querySelectorAll(".vacature-section").forEach((section) => {
            const toggle = section.querySelector(".vacature-section-toggle");
            const panel = section.querySelector(".vacature-section-panel");
            if (!toggle || !panel) return;

            toggle.addEventListener("click", () => {
                const open = toggle.getAttribute("aria-expanded") !== "true";
                toggle.setAttribute("aria-expanded", String(open));
                section.classList.toggle("is-open", open);
                panel.inert = !open;
            });
        });
    });
});
